<template>
  <div class="go-top" @click="goTop"></div>
</template>

<script>

export default {
  name: 'FootView',
  data() {
    return {
    }
  },
  methods: {
    // 返回顶部
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
  }
}
</script>
<style scoped lang="scss">
.go-top {
  z-index: 15;
  position:fixed;
  right: 20px;
  bottom: 200px;
  width: 100px;
  height: 100px;
  background: url('../../assets/up2.png') no-repeat;
  background-size: 100%;
}
</style>
